import styled, { css } from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  lineHeight,
  neutral,
  radius,
  shadow,
  space,
  transition,
} from '../../../theme/tokens';
import { StudentHeader } from '../../common/elements/Students.js';

export const TargetHeader = styled(StudentHeader)`
  margin: 0;
`;

export const TargetLi = styled.li`
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.normal};
  color: ${({ theme, complete }) =>
    complete
      ? theme.isTargetDark
        ? theme.textLight
        : theme.headerColour
      : theme.headerColour};
  background: ${({ theme, complete }) =>
    complete ? theme.targetHighlight : neutral.subtle};
  border-radius: ${radius.lg};
  padding: ${space[4]};
  width: 100%;
  margin: ${space[4]} 0;
  white-space: pre-line;
  overflow-wrap: anywhere;
  transition: box-shadow ${transition.fast};

  ${({ isTop }) =>
    isTop &&
    css`
      margin-top: 0;
    `}

  &:hover {
    cursor: pointer;
    box-shadow: ${shadow.md};
  }

  ${({ notClickable }) =>
    notClickable &&
    css`
      &:hover {
        cursor: default;
        box-shadow: none;
      }
    `}

  ${({ hasNotifications }) =>
    hasNotifications &&
    css`
      margin: 0;
    `}
`;

export const TargetText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
`;

export * from '../../common/elements/Notifications';
export * from '../../common/elements/Students';
